import { Entitlements } from '@experiences/constants';
import {
    Features,
    useFeatureFlagValue,
} from '@experiences/feature-flags';
import React from 'react';
import { useSelector } from 'react-redux';

import useCanAccessUsageInsights from '../../common/hooks/useCanAccessUsageInsights';
import InvalidUrl from '../../component/authentication/InvalidUrl';
import { useEntitlements } from '../../component/entitlements/EntitlementsContextProvider';
import { isHostModeSelector } from '../../store/selectors';

const OrganizationLevelDashboard = React.lazy(() => import('../../component/licensing/consumptionDashboard/OrganizationLevelDashboard'));
const TenantLevelDashboard = React.lazy(() => import('../../component/licensing/consumptionDashboard/TenantLevelDashboard'));

const useCanAccessConsumptionDashboard = () => {
    const EnableConsumptionDashboardView = useFeatureFlagValue(Features.EnableConsumptionDashboardView.name);
    const EnableConsumptionDashboardSap = useFeatureFlagValue(Features.EnableConsumptionDashboardSap.name);
    const isHostMode = useSelector(isHostModeSelector);
    const { hasEntitlement } = useEntitlements();
    const isSapOrganization = hasEntitlement(Entitlements.PlatformSapEnabled);
    const canAccessUsageInsights = useCanAccessUsageInsights();

    return EnableConsumptionDashboardView
        && !isHostMode
        && canAccessUsageInsights
        && (!isSapOrganization || EnableConsumptionDashboardSap);
};

export const OrganizationConsumptionDashboardRoute: React.FC = () => {
    const canAccess = useCanAccessConsumptionDashboard();
    if (!canAccess) {
        return <InvalidUrl />;
    }
    return <OrganizationLevelDashboard />;
};

export const TenantConsumptionDashboardRoute: React.FC = () => {
    const canAccess = useCanAccessConsumptionDashboard();
    if (!canAccess) {
        return <InvalidUrl />;
    }
    return <TenantLevelDashboard />;
};
